import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
     Row, Col, Label,
     Input, InputGroup,
     FormFeedback, TabContent,
     TabPane, Nav, NavItem,
     NavLink, Card, Button,
     CardTitle, CardText,
} from 'reactstrap';

import ParadigmaLabeledInput from "../../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../../api";

import ArticulosModal from './ArticulosModal.js';

import '../styles.css';

class TabDetalle extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {vars, getError, onChangeField, data} = this.props;

        return (
        <TabPane tabId="1" className="">
          <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[2, 10]}
          label={"Descripción"}
          value={data.descripcion}
          onChange={(e) => onChangeField('descripcion', e.target.value)}
          error={() => getError('descripcion')}
          />
          <ParadigmaLabeledInput
          disabled={vars.disabled}
          md={[2, 10]}
          label={"Titulo en Web"}
          value={data.titulo}
          onChange={(e) => onChangeField('titulo', e.target.value)}
          error={() => getError('titulo')}
          />
          {
               data.action != "DELETE" &&
               <Row className="mt-2">
               <Col>
                <ArticulosModal
                vars={vars}
                data={data}
                onChangeField={(...data) => onChangeField(...data)}
                />
               </Col>
               </Row>
          }
        </TabPane>
        );
    }
}

export default TabDetalle;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/TabDetalle.js